import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type {
	EditorContentFragmentResult,
	EditorContentFragmentValue,
} from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { SmartCreateFeedbackBannerQuery$data } from './__generated__/SmartCreateFeedbackBannerQuery.graphql.ts';
import type { useSmartCreateFeedbackBannerFragment_content$key } from './__generated__/useSmartCreateFeedbackBannerFragment_content.graphql.ts';

// Information used to determine whether to render the "This content was created with Rovo! We’d love to hear what you think." banner.
const smartCreateFeedbackBannerFragmentNode: GraphQLTaggedNode = graphql`
	fragment useSmartCreateFeedbackBannerFragment_content on Content @catch {
		title
		id
		type
		creatorId
		version {
			number
		}
		history {
			createdDate
		}
		contentProperties {
			draft {
				generatedBy
			}
			latest {
				generatedBy
			}
		}
	}
`;

export function useSmartCreateFeedbackBannerFragment({
	contentId,
	skip,
}: {
	contentId: string | undefined;
	skip: boolean;
}): EditorContentFragmentResult<SmartCreateFeedbackBannerQuery$data> {
	return useEditorContentFragment<
		useSmartCreateFeedbackBannerFragment_content$key,
		SmartCreateFeedbackBannerQuery$data
	>('smartCreateFeedbackBannerFragment', smartCreateFeedbackBannerFragmentNode, {
		contentId,
		skip,
		mapData: (
			value: EditorContentFragmentValue<useSmartCreateFeedbackBannerFragment_content$key>,
		) => ({ singleContent: value }),
	});
}
